import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-prompt-dialog',
    templateUrl: './prompt-dialog.component.html',
    styleUrls: ['./prompt-dialog.component.css'],
    standalone: false
})
export class PromptDialogComponent implements OnInit {

  promptTitle!:string;
  promptMessage!:string;

  constructor(@Inject(MAT_DIALOG_DATA) public data :any, private dialogRef: MatDialogRef<PromptDialogComponent>) { }

  ngOnInit(): void {
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

  onDeclineClick(): void {
    this.dialogRef.close(false);
  }

  onCancelClick(){}

}
